import { useEffect, useMemo } from 'react'

import { useSearchOrders } from '@apps-common/apis/portal/orders/search-orders'
import { useSearchOrdersCount } from '@apps-common/apis/portal/orders/search-orders-count'
import { Table } from '@apps-common/components/elements/table'
import { LayoutContainer, LayoutPadding, VertSpacerXl } from '@apps-common/components/layout'
import { useIsManagement } from '@apps-common/hooks/useIsManagement'
import { useNavigation } from '@apps-common/hooks/useNavigation'
import { usePortalOrderFilterStore } from '@apps-common/stores'

import { RootHeaderButtons } from '@apps-common/components/common'
import { PageClearFilterButton, PageResultsCount } from '@apps-common/components/page'
import { managementOrderTableKeys } from './management'
import { OrdersHeader } from './OrdersHeader'
import { portalOrderTableKeys } from './portal'

export const OrdersTableView = () => {
  const { isManagement } = useIsManagement()
  const { navigateForward } = useNavigation()
  const filter = usePortalOrderFilterStore()

  const {
    data: countData,
    isLoading: countIsLoading,
    isError: countIsError,
    refetch: countRefetch
  } = useSearchOrdersCount({
    model: filter.getSearchParams()
  })

  const {
    data: ordersData,
    isLoading: ordersIsLoading,
    isFetching: ordersIsFetching,
    isRefetching: ordersIsRefetching,
    isError: ordersIsError,
    refetch: ordersRefetch
  } = useSearchOrders({
    model: filter.getSearchParams()
  })

  useEffect(() => {
    const element = document.getElementById('orders-table-container')

    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }, [ordersIsLoading])

  const tableKeys = useMemo(() => {
    if (isManagement) {
      return managementOrderTableKeys(navigateForward)
    }

    return portalOrderTableKeys(navigateForward)
  }, [isManagement])

  const countLoading = countIsLoading || countIsError
  const loading = ordersIsLoading || ordersIsFetching || ordersIsRefetching || ordersIsError || countLoading

  return (
    <>
      <OrdersHeader
        icons={<RootHeaderButtons />}
        leftComponent={<PageResultsCount loading={countLoading} count={countData} />}
        rightComponent={<PageClearFilterButton filter={filter} filterKeyWordsFunc={filter.getFilteredByKeywords} callback={filter.clear} />}
        loading={countLoading}
        navigateForward={navigateForward}
        searchCount={countData?.resultCount || -1}
      />
      <LayoutContainer id='orders-table-container'>
        <LayoutPadding topPadding='pt-[20px] md:pt-[20px]'>
          <div className='max-w-full'>
            <Table
              loading={loading}
              loadingSkeletonHeight='leading-[30px]'
              placeholderSkeletonHeight='leading-[30px]'
              pagination={{
                loading: countLoading,
                count: countData?.resultCount,
                skip: filter.skip,
                take: filter.take,
                onSkipChanged: (value) => filter.setSkip(value),
                onTakeChanged: (value) => filter.setTake(value)
              }}
              keys={tableKeys}
              data={ordersData}
              onSkipChanged={(value) => filter.setSkip(value)}
              onTakeChanged={(value) => filter.setTake(value)}
            />
          </div>
        </LayoutPadding>
        <VertSpacerXl />
      </LayoutContainer>
    </>
  )
}
